
    const gridCont = document.querySelector(".grid.grid--uniform.grid-products.grid--view-items");
    const collectionsSwiper = document.querySelector(".metacol-slider.page-width");
    if (collectionsSwiper) {
        collectionsSwiper.classList.add("FDR-collections");
    }

    const filters = document.querySelectorAll(".main-all.all-filter-collection.sidebar span");
    const filteredFilters = Array.from([...filters].filter((filter) => filter.hasAttribute("id")));

    const filtersBar = document.querySelector(".filterbar.left");
    const newFiltersBar = document.createElement("div");
    newFiltersBar.classList.add("FDR-filters-bar");
    newFiltersBar.innerHTML = `
    <div class="FDR-filters__left">
        <button class="FDR-button FDR-show-all-filters" role="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M18.3337 2.5H1.66699L8.33366 10.3833V15.8333L11.667 17.5V10.3833L18.3337 2.5Z" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span> All Filters </span>
        </button>
    </div>
    <div class="FDR-filters__middle">
        <p> Filter by: </p>
        ${filteredFilters
            .map(
                (filter) => `
            <button class="FDR-button FDR-${filter.id} ${filter.id}" role="button"> ${filter.id} </button>
        `
            )
            .join("")}
    </div>
    <div class="FDR-filters__right">
        <p> Sort by: </p>
    </div>
`;

    document.addEventListener("mouseup", (e) => {
        const filters_cont = document.querySelector(".main-all.all-filter-collection.sidebar");

        if (e.target.closest(".FDR-show-all-filters")) {
            if (window.innerWidth > 1024) {
                filters_cont.querySelector(".widget-title").click();
            }
        }

        filteredFilters.forEach((filter) => {
            if (e.target.closest(`.FDR-${filter.id}`)) {
                const filterElement = filters_cont.querySelector(`#${filter.id}`);
                if (filterElement) {
                    filterElement.click();
                }
            }
        });
    });

    if (!document.querySelector(".FDR-filters-bar")) {
        filtersBar.after(newFiltersBar);
    }

    const sortBy = document.querySelector(".filters-toolbar__item.text-right");
    const viewAs = document.querySelector(".filters-toolbar__item.collection-view-as");

    if (!document.querySelector(".FDR-filters__right .filters-toolbar__item.text-right")) {
        document.querySelector(".FDR-filters__right").appendChild(sortBy);
    }

    if (window.innerWidth > 1023) {
        document.querySelector(".FDR-filters__right").appendChild(viewAs);
    }

    if (window.innerWidth < 1024) {
        const mobileFilterButton = document.querySelector(".filters-toolbar.flex .btn.btn-filter.large-up--hide");
        document.querySelector(".FDR-show-all-filters").appendChild(mobileFilterButton);
    }
    setTimeout(() => {
        const swiperContainer = document.querySelector(".metacol-Swiper");
        const slideCount = document.querySelectorAll(".metacol-Swiper .swiper-slide").length;
        
        if (slideCount < 5) {
            swiperContainer.classList.add("swiper-few-items");
        } else {
            swiperContainer.classList.remove("swiper-few-items");
        }
        
        if (slideCount === 2) {
            swiperContainer.classList.add("swiper-two-items");
        } else {
            swiperContainer.classList.remove("swiper-two-items");
        }

        let swiperInstance;

        if (swiperContainer.swiper) {
            swiperInstance = swiperContainer.swiper;
            swiperInstance.destroy(true, true);
        }

        swiperInstance = new Swiper(".metacol-Swiper", {
            slidesPerView: 3,
            spaceBetween: 20,
            speed: 250,
            breakpoints: {
                768: {
                    slidesPerView: 5,
                }
            },
        });
    }, 100);
